import * as React from 'react';
import { differenceCode } from './unit';
import {
  Badge,
  Table
} from 'antd';

export default function invoiceCompared(record: any, documentUuid: string) {
  let { comparisonResult = {} } = record;
  let { comparisonResultList = [] } = comparisonResult;
  let differenceResultValue = '金额',
  comparisonRule;
  if (comparisonResultList.length > 0) {
    comparisonRule = comparisonResultList[0]['comparisonRule'];
    if (comparisonRule === 1) {
      differenceResultValue = differenceCode[comparisonResultList[0]['marginValueSourceFieldName']];
    } else if (comparisonRule === 2) {
      differenceResultValue = differenceCode[comparisonResultList[0]['marginRateSourceFieldName']];
    }
  }
  const columns = [
    {
      dataIndex: 'documentType', 
      key: 'documentType', 
      width: 60,
      render: (text, recordIn) => {
        const documentUuidIn = recordIn.documentUuid;
        if (documentUuidIn === documentUuid) {
          return <Badge count="当前" style={{ backgroundColor: '#1A91EB' }} />;
        }
        return text === 'Invoice' ? <Badge count="关联" style={{ backgroundColor: '#EC4C1C' }} /> : 
        <Badge count="比对" style={{ backgroundColor: '#F8B551' }} />;
      }
    },
    { 
      title: '',
      dataIndex: 'targetDocumentId',
      key: 'targetDocumentId',
      width: 500,
      render: (text, recordIn) => {
        const { documentType, targetDocumentId, sourceDocumentId,  } = recordIn;
        return (
          <>
            {
              documentType === 'Invoice' ? '发票' : '匹配对账单'
            }
            <span style={{ display: 'inline-block', marginLeft: '12px' }}>{ documentType === 'Invoice' ? targetDocumentId : sourceDocumentId }</span>
          </>
        );
      }
    },
    {
      title: '',
      dataIndex: 'documentUuid',
      key: 'documentUuid',
      render: (text, recordIn) => {
        const { documentType, differenceMarginValue, differenceMarginRate, marginValueSourceFieldValue, marginValueTargetFieldValue, marginRateSourceFieldValue, marginRateTargetFieldValue,} = recordIn;
        return (
          <>
            <span>{`${differenceResultValue}: `}</span>
            { 
              comparisonRule === 1 ? 
              ( documentType === 'Invoice' ? marginValueTargetFieldValue : marginValueSourceFieldValue ) :
              ( documentType === 'Invoice' ? marginRateTargetFieldValue : marginRateSourceFieldValue ) 
            }
            <span style={{ color: '#EC6941', display: 'inline-block', marginLeft: '12px' }}>{comparisonRule === 1 ? differenceMarginValue : differenceMarginRate}</span>
          </>
        );
      }
    },
  ];
    return (
    <Table
      columns={columns}
      dataSource={comparisonResultList}
      pagination={false}
      showHeader={false}
    />
  );
}


// WEBPACK FOOTER //
// ./src/display/platform/Document/InvoiceDetail/invoiceCompared.tsx